import { PaymentPlan } from 'api/clients/PaymentPlanClient'
import { useCurrentWorkspace } from './useCurrentWorkspace'

export const useEligiblePlan = () => {
  const workspace = useCurrentWorkspace()

  return (plan: PaymentPlan) => {
    if (!plan.member_limit || !workspace) return true

    return workspace.members_count <= plan.member_limit
  }
}
